<template>
  <Accordion
    id="info-calc"
    title="IMPOSTOS"
    :rightTitle="`Total da Nota ${valorReal(taxCalc.vNF)}`"
  >
    <b-row class="row-padding align-items-end">
      <b-col md="6" lg="2">
        <Label>Base Cálc. ICMS:</Label>
        <InputMoney
          aria-required="true"
          disabled
          :precision="2"
          :prefix="false"
          :value="valorReal(taxCalc.vBC)"
        />
      </b-col>
      <b-col md="6" lg="2">
        <Label>Valor do ICMS:</Label>
        <InputMoney
          aria-required="true"
          disabled
          :prefix="false"
          :precision="2"
          :value="valorReal(taxCalc.vICMS)"
        />
      </b-col>
      <b-col md="6" lg="2">
        <Label>Base Cálc. ICMS ST:</Label>
        <InputMoney
          aria-required="true"
          disabled
          :prefix="false"
          :precision="2"
          :value="valorReal(taxCalc.vBCST)"
        />
      </b-col>
      <b-col md="6" lg="2">
        <Label>Valor do ICMS ST:</Label>
        <InputMoney
          aria-required="true"
          disabled
          :prefix="false"
          :precision="2"
          :value="valorReal(taxCalc.vICMSST)"
        />
      </b-col>
      <b-col md="6" lg="2">
        <Label>ICMS Desonerado:</Label>
        <InputMoney
          aria-required="true"
          disabled
          :prefix="false"
          :precision="2"
          :value="valorReal(taxCalc.vICMSDeson)"
        />
      </b-col>
      <b-col md="6" lg="2">
        <Label>Valor FCP ST:</Label>
        <InputMoney
          aria-required="true"
          disabled
          :prefix="false"
          :precision="2"
          :value="valorReal(taxCalc.vFCPST)"
        />
      </b-col>
    </b-row>
    <b-row class="row-padding align-items-end pt-0">
      <b-col md="6" lg="2">
        <Label>Desconto:</Label>
        <InputMoney
          aria-required="true"
          :prefix="false"
          :precision="2"
          :onKeyup="vDescDebounce"
          v-model="taxCalc.vDesc"
        />
      </b-col>
      <b-col md="6" lg="2">
        <Label>Frete:</Label>
        <InputMoney
          aria-required="true"
          :prefix="false"
          :precision="2"
          :onKeyup="attributesDebounce"
          v-model="taxCalc.vFrete"
        />
      </b-col>
      <b-col md="6" lg="2">
        <Label>Seguro:</Label>
        <InputMoney
          aria-required="true"
          :prefix="false"
          :precision="2"
          :onKeyup="attributesDebounce"
          v-model="taxCalc.vSeg"
        />
      </b-col>
      <b-col md="6" lg="2">
        <Label>Outras Despesas:</Label>
        <InputMoney
          aria-required="true"
          :prefix="false"
          :precision="2"
          :onKeyup="attributesDebounce"
          v-model="taxCalc.vOutro"
        />
      </b-col>
      <b-col md="6" lg="2">
        <Label>Valor do IPI:</Label>
        <InputMoney
          aria-required="true"
          disabled
          :prefix="false"
          :precision="2"
          :value="valorReal(taxCalc.vIPI)"
        />
      </b-col>
      <b-col md="6" lg="2">
        <Label>Total dos Produtos:</Label>
        <InputMoney
          aria-required="true"
          :value="valorReal(taxCalc.vProd)"
          disabled
          :precision="2"
          aria-placeholder="Informe um produto"
        />
      </b-col>
    </b-row>

    <b-row class="row-padding justify-content-md-end">
      <b-col md="6" lg="2">
        <Label>Total da Nota:</Label>
        <InputMoney aria-required="true" disabled :precision="2" :value="valorReal(taxCalc.vNF)" />
      </b-col>
    </b-row>
    <IBSRegimeTaxesData :IbsTaxRegimeTotals="taxCalc.IBSTaxRegime" />
  </Accordion>
</template>

<script>
import { Accordion } from '@/components';
import { Label, InputMoney } from '@/components/Form';
import { mapActions, mapState } from 'vuex';
import { CalcTypesPurchaseEnum } from '@/modules/Fiscal/enums/CalcTypesEnum';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import * as _ from 'lodash';
import IBSRegimeTaxesData from '@/modules/Fiscal/modules/IBSRegime/components/totals/IBSRegimeTaxesData.vue';

export default {
  name: 'taxCalc',
  mixins: [FormatMixin],
  components: {
    Label,
    Accordion,
    InputMoney,
    IBSRegimeTaxesData,
  },
  computed: {
    ...mapState('purchase', ['taxCalc']),
  },
  created() {
    this.vDescDebounce = _.debounce(async () => {
      await this.totalCalcPurchase({
        calcTypes: [
          CalcTypesPurchaseEnum.TOTAL_DESC_BASED_ON_TOTAL,
          CalcTypesPurchaseEnum.TOTAL_NF,
          CalcTypesPurchaseEnum.TOTAL_TAX_REGIME,
        ],
      });
    }, 1000);
    this.attributesDebounce = _.debounce(async () => {
      await this.totalCalcPurchase({
        calcTypes: [
          CalcTypesPurchaseEnum.TOTAL_COMMON,
          CalcTypesPurchaseEnum.TOTAL_NF,
          CalcTypesPurchaseEnum.TOTAL_TAX_REGIME,
        ],
      });
    }, 1000);
  },
  methods: {
    ...mapActions('purchase', ['totalCalcPurchase']),
  },
};
</script>
